// 备注：在setinterval中使用aysnc await语法，部分浏览器会报unexpected token function（建议使用.then()）
import axios from 'axios'
var config = require('../js/config.js')
var utils = require('./utility/utility.js')

// 默认请求公共地址、头部信息
var domainUrl = config.address
var commomHeaders = config.commomHeaders
// 4.0s地址
var domainUrl4s = config.commonAddress4S

// post请求
var post = function (url, data) {
	data = data || '';
	// 判断本地存储token是否存在
	let localUserInfo = utils.localUserInfo
	if (localUserInfo.getItem()) {
		// console.log(localUserInfo.getItem())
		commomHeaders.Authorization = localUserInfo.getItem().apitoken
	}
	// console.log('commomHeaders', commomHeaders)

	return new Promise(function (resolve, reject) {
		axios({
			method: 'post',
			url: domainUrl + url,
			headers: commomHeaders,
			data: data
		})
		.then(function (res) {
			// console.log('res.data', res.data)
			// 用户token过期，提示用户重新登录
			if (res.data.meta.code === 401) {
				utils.showToast('登录已过期！请重新登录')
				// 登录过期，清空缓存数据
				localStorage.clear()
				sessionStorage.clear()
				window.location.href = '/'
				return false
			}
			// console.log('data::', res.data)
			resolve(res.data)
		})
		.catch(function (error) {
			utils.hideLoading()
			utils.showToast('连接服务器失败，取消操作请重试！')
			console.log('error', error)
			reject(error)
		})
	})
}

// multipart/form-data格式的post请求
let formDataPost = function (url, data) {
	data = data || '';
	let headers = {
		'Content-Type': 'multipart/form-data'
	}
	// 判断本地存储token是否存在
	let localUserInfo = utils.localUserInfo
	if (localUserInfo.getItem()) {
		// console.log(localUserInfo.getItem())
		headers.Authorization = localUserInfo.getItem().apitoken
	}
	// console.log('headers', headers)

	return new Promise(function (resolve, reject) {
		axios({
			method: 'post',
			url: domainUrl + url,
			headers: headers,
			data: data
		})
			.then(function (res) {
				// console.log('res.data', res.data)
				// 用户token过期，提示用户重新登录
				if (res.data.meta.code === 401) {
					utils.showToast('登录已过期！请重新登录')
					// 登录过期，清空缓存数据
					localStorage.clear()
					sessionStorage.clear()
					window.location.href = '/'
					return false
				}
				resolve(res.data)
			})
			.catch(function (error) {
				utils.hideLoading()
				utils.showToast('连接服务器失败，取消操作请重试！')
				console.log('error', error)
				reject(error)
			})
	})
}

// 公共post请求
var commonPost = function (url, data) {
	data = data || '';
	// 判断本地存储token是否存在
	let localUserInfo = utils.localUserInfo
	if (localUserInfo.getItem()) {
		commomHeaders.Authorization = localUserInfo.getItem().apitoken
	}

	return new Promise(function (resolve, reject) {
		axios({
			method: 'post',
			url: config.commonAddress + url,
			headers: commomHeaders,
			data: data
		})
			.then(function (res) {
				// console.log('res.data', res.data)
				// 用户token过期，提示用户重新登录
				if (res.data.meta.code === 401) {
					utils.showToast('登录已过期！请重新登录')
					// 登录过期，清空缓存数据
					localStorage.clear()
					sessionStorage.clear()
					window.location.href = '/'
					return false
				}
				resolve(res.data)
			})
			.catch(function (error) {
				utils.hideLoading()
				utils.showToast('连接服务器失败，取消操作请重试！')
				console.log('error', error)
				reject(error)
			})
	})
}

// 不验证身份公共post请求(仅供phonePage使用)
var noCommonPost = function (url, data, file) {
	data = data || '';
	// console.log('commomHeaders', commomHeaders)
	if (file) {
		commomHeaders = {
			'Content-Type': 'multipart/form-data'
		}
	}

	return new Promise(function (resolve, reject) {
		axios({
			method: 'post',
			url: config.commonAddress + url,
			headers: commomHeaders,
			data: data
		})
			.then(function (res) {
				// console.log('res.data', res.data)
				resolve(res.data)
			})
			.catch(function (error) {
				utils.hideLoading()
				utils.showToast('连接服务器失败，取消操作请重试！')
				console.log('error', error)
				reject(error)
			})
	})
}

// 小程序webview页面请求(仅供phonePage使用)
var appletPost = function (url, data, file) {
	data = data || '';
	// console.log('commomHeaders', commomHeaders)
	// console.log('uril', config.commonAddress.replace(/http/, "https") + url)
	let address = config.commonAddress.replace(/http/, "https")
	address = address.replace(/:81/, '')
	console.log('address:' + address)
	if (file) {
		commomHeaders = {
			'Content-Type': 'multipart/form-data'
		}
	}

	return new Promise(function (resolve, reject) {
		axios({
			method: 'post',
			url: address + url,
			headers: commomHeaders,
			data: data
		})
			.then(function (res) {
				// console.log('res.data', res.data)
				resolve(res.data)
			})
			.catch(function (error) {
				utils.hideLoading()
				utils.showToast('连接服务器失败，取消操作请重试！')
				console.log('error', error)
				reject(error)
			})
	})
}

// 小程序webview页面请求4.0s(仅供phonePage使用)
var appletPost4s = function (url, data, file) {
	data = data || '';
	// console.log('commomHeaders', commomHeaders)
	// console.log('uril', config.commonAddress.replace(/http/, "https") + url)
	let address = domainUrl4s.replace(/http/, "https")
	console.log('address:' + address)
	if (file) {
		commomHeaders = {
			'Content-Type': 'multipart/form-data'
		}
	}

	return new Promise(function (resolve, reject) {
		axios({
			method: 'post',
			url: address + url,
			headers: commomHeaders,
			data: data
		})
			.then(function (res) {
				// console.log('res.data', res.data)
				resolve(res.data)
			})
			.catch(function (error) {
				utils.hideLoading()
				utils.showToast('连接服务器失败，取消操作请重试！')
				console.log('error', error)
				reject(error)
			})
	})
}

// 不验证身份公共post4.0s请求(仅供phonePage使用)
var noCommonPost4s = function (url, data, file) {
	data = data || '';
	// console.log('commomHeaders', commomHeaders)
	if (file) {
		commomHeaders = {
			'Content-Type': 'multipart/form-data'
		}
	}

	return new Promise(function (resolve, reject) {
		axios({
			method: 'post',
			url: domainUrl4s + url,
			headers: commomHeaders,
			data: data
		})
			.then(function (res) {
				// console.log('res.data', res.data)
				resolve(res.data)
			})
			.catch(function (error) {
				utils.hideLoading()
				utils.showToast('连接服务器失败，取消操作请重试！')
				console.log('error', error)
				reject(error)
			})
	})
}

// post请求4.0s
var post4s = function (url, data) {
	data = data || '';
	// 判断本地存储token是否存在
	let localUserInfo = utils.localUserInfo
	if (localUserInfo.getItem()) {
		// console.log(localUserInfo.getItem())
		// delete commomHeaders.Authorization
		commomHeaders.Authorization = localUserInfo.getItem().apitoken
	}
	// console.log('commomHeaders', commomHeaders)

	return new Promise(function (resolve, reject) {
		axios({
			method: 'post',
			url: domainUrl4s + url,
			headers: commomHeaders,
			data: data
		})
		.then(function (res) {
			// console.log('res.data', res.data)
			// 用户token过期，提示用户重新登录
			// if (res.data.meta.code === 401) {
			// 	utils.showToast('登录已过期！请重新登录')
			// 	// 登录过期，清空缓存数据
			// 	localStorage.clear()
			// 	sessionStorage.clear()
			// 	window.location.href = '/'
			// 	return false
			// }
			resolve(res.data)
		})
		.catch(function (error) {
			utils.hideLoading()
			utils.showToast('连接服务器失败，取消操作请重试！')
			console.log('error', error)
			reject(error)
		})
	})
}


export {
	post,
	formDataPost,
	commonPost,
	noCommonPost,
	appletPost,
	noCommonPost4s,
	appletPost4s,
	post4s
}



//////////////////
// WEBPACK FOOTER
// ./static/js/request.js
// module id = tY+N
// module chunks = 1